exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chapter-tree[data-v-e3d2395e]::-webkit-scrollbar{width:6px}.chapter-tree[data-v-e3d2395e]  .el-tree-node__content{height:36px}", ""]);

// exports
